<template>
  <v-card :color="customColor" class="fipa--header" v-bind="$attrs" tile>
    <v-row no-gutters align="center" class="header-lower-font">
      <v-col :cols="singleCol ? 12 : leftCols">
        <div><slot name="left" /></div>
      </v-col>
      <v-col v-if="!singleCol" :cols="rightCols" class="text-right">
        <div
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <slot name="right" />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppTableHeader",
  props: {
    customColor: {
      type: String,
      default: "primary"
    },
    singleCol: {
      type: Boolean,
      default: false
    },
    leftCols: {
      type: Number,
      default: undefined
    },
    rightCols: {
      type: Number,
      default: undefined
    }
  }
});
</script>
